import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const updateLeader = ({
  leaderData,
  churchId,
  leaderId,
  isDenominationChurch = false
}) => {
  if (isDenominationChurch) {
    return axios.post(
      `/denomination-churches/${churchId}/leaders/${leaderId}?_method=PUT`,
      leaderData
    );
  }
  return axios.post(
    `/churches/${churchId}/leaders/${leaderId}?_method=PATCH`,
    leaderData
  );
};

export const useUpdateLeader = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("leaders");
      setNotification({
        type: "success",
        message: "Leader updated successfully!"
      });
    },
    ...config,
    mutationFn: updateLeader
  });
};
